import { render } from "./BtnVoltar.vue?vue&type=template&id=578f0642"
import script from "./BtnVoltar.vue?vue&type=script&lang=js"
export * from "./BtnVoltar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/samuelquaresma/Documents/Dev/DAF/app-capacitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__